import moment from "moment";
import { ReactInstance } from "react";
import { AuthorizedOperation, Operations, OrderAction, OrderStatus, OrderType } from "./Enums";
import i18n from "./i18n";


export const timestampToDate = (seconds: number | undefined, nanos: number | undefined, asUTC = false): Date | undefined => {

    if (seconds) {

        const a = new Date(seconds * 1000);
        if (nanos)
            a.setMilliseconds((nanos) / 1e6)

        if (asUTC) {
            let localDate = new Date(a.getTime() + (new Date()).getTimezoneOffset() * 60000); // Adjust by offset
            return localDate;
        }
        return a;
    }

}


export const formatDate = (date: Date | undefined, format = 'YYYY-MM-DD HH:mm:ss'): string => {

    return moment(date).format(format);

}

export const phoneNumberFormatter = (PhoneNumber: string): string | undefined => {
  if(PhoneNumber == undefined){
        return undefined
    }
    PhoneNumber = PhoneNumber.trim();
    PhoneNumber = PhoneNumber.replace('\u0660', '0')
        .replace('\u0661', '1')
        .replace('\u0662', '2')
        .replace('\u0663', '3')
        .replace('\u0664', '4')
        .replace('\u0665', '5')
        .replace('\u0666', '6')
        .replace('\u0667', '7')
        .replace('\u0668', '8')
        .replace('\u0669', '9'); // ٠٩١٤٢٦٧٣١٥ cases
    if (PhoneNumber.length >= 8) {
        PhoneNumber = PhoneNumber.trim().replace(" ", "").replace("+", "").replace("-", ""); // Remove spaces, +, -
        if (PhoneNumber.length < 4)
            return undefined;
        let isAllDigits = /^\d+$/.test(PhoneNumber);
        if (!isAllDigits)
            return undefined;
        if (PhoneNumber.length > 15)
            return undefined;

        if (PhoneNumber.startsWith("00")) {
            PhoneNumber = PhoneNumber.substring(2); // 00218912129959 => 218912129959
        }
        else if (PhoneNumber.startsWith("09")) // Local case
        {
            PhoneNumber = "218" + PhoneNumber.substring(1); // 0912129599 => 218912129959
        }
        return PhoneNumber;
    }
    return undefined;

}

export const getCurrentLanguage = (): string => {

    var lang = i18n.language || localStorage.getItem("lang") || 'ar'
    return lang;

}

export const normalizeKey = (key: string) => key as unknown as TemplateStringsArray;

export const currencyFormatter = (value: number, options: any) => {


    options = {
        ...{
            thousandsSeparator: ',',
            decimalSeparator: '.',
        }, ...options
    }
    let num = Number(value);
    if (isNaN(num)) {
        return ''
    }
    let minus = ""
    if (num < 0) {
        num = num * -1;
        minus = "-"
    }
    let v = options.significantDigits == undefined ? num + "" : num.toFixed(options.significantDigits)


    const [currency, decimal] = v.split('.')
    if (options.symbol == undefined) {
        if (options.significantDigits == 0) {
            return `${currency.replace(
                /\B(?=(\d{3})+(?!\d))/g,

                options.thousandsSeparator
            )}${minus}`
        } else {
            return `${currency.replace(
                /\B(?=(\d{3})+(?!\d))/g,

                options.thousandsSeparator
            )}${options.decimalSeparator}${decimal ?? "0"}${minus}`
        }


    }
    if (isRTL(options.symbol)) {
        if (options.significantDigits == 0) {
            return `${currency.replace(
                /\B(?=(\d{3})+(?!\d))/g,

                options.thousandsSeparator
            )}${minus} ${options.symbol}`
        } else {
            return `${currency.replace(
                /\B(?=(\d{3})+(?!\d))/g,

                options.thousandsSeparator
            )}${options.decimalSeparator}${decimal ?? "0"}${minus} ${options.symbol}`
        }

    }
    if (options.significantDigits == 0) {
        return `${options.symbol}${minus}${currency.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            options.thousandsSeparator
        )}`
    } else {
        return `${options.symbol}${minus}${currency.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            options.thousandsSeparator
        )}${options.decimalSeparator}${decimal ?? "0"}`
    }


}

export const isRTL = (text: string): boolean => {

    let regexp = new RegExp('[\u0600-\u06FF]+')
    return regexp.test(text);

}


export const printComponent = (html?: any, isTable: boolean = false): ReactInstance => {

    const PrintElem = document.createElement('div');
    PrintElem.className = isTable ? "table_printing_content" : "printing_content"
    const header =
        `<br><b>${formatDate(new Date())}</b>` +
        `<br><b>${window.location.href}</b>`
    PrintElem.innerHTML = header;
    PrintElem.appendChild(html);
    return PrintElem
}




export const base64ToArrayBuffer = (e: string) => {
    var binary_string = window.atob(e);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

export const downloadFile = (base64Data: string, fileName: string) => {
    var data = new Blob([base64ToArrayBuffer(base64Data)]);
    var csvURL = window.URL.createObjectURL(data);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', fileName);
    tempLink.click();

}

export const getFileExtension = (type: number): string => {
    return type == 1 ? ".xlsx" : type == 2 ? ".csv" : type == 3 ? ".pdf" : ".txt";
}

/**
 * Rounds a timestamp down to the beginning of a specified interval.
 *
 * @param {number} timestamp - The input timestamp in milliseconds.
 * @param {number} bucketCode - The bucket code indicating the desired interval:
 *                              0: minute,
 *                              1: 15 minutes,
 *                              2: 30 minutes,
 *                              3: hour,
 *                              4: 4 hours,
 *                              5: day,
 *                              6: week (first day is Saturday),
 *                              7: month.
 * @returns {number} The timestamp (in milliseconds) corresponding to the beginning of the bucket.
 *
 * @throws {Error} If an unsupported bucket code is provided.
 */
export const roundTimestamp = (timestamp: any, bucketCode: string) => {
    const date = new Date(timestamp);
    // ["1S", "1", "15", "30", "60", "240", "1D", "1W", "1M"],
    switch (bucketCode) {
        case "1S": { // Beginning of minute
            date.setMilliseconds(0);
            break;
        }
        case "1": { // Beginning of minute
            date.setSeconds(0, 0);
            break;
        }
        case "15": { // Beginning of 15-minute period
            date.setSeconds(0, 0);
            const minutes = date.getMinutes();
            date.setMinutes(Math.floor(minutes / 15) * 15);
            break;
        }
        case "30": { // Beginning of 30-minute period
            date.setSeconds(0, 0);
            const minutes = date.getMinutes();
            date.setMinutes(Math.floor(minutes / 30) * 30);
            break;
        }
        case "60": { // Beginning of hour
            date.setMinutes(0, 0, 0);
            break;
        }
        case "240": { // Beginning of 4-hour block
            date.setMinutes(0, 0, 0);
            const hours = date.getHours();
            date.setHours(Math.floor(hours / 4) * 4);
            break;
        }
        case "1D": { // Beginning of day
            date.setHours(0, 0, 0, 0);
            break;
        }
        case "1W": {  // Beginning of week (with Saturday as the first day)
            // First, set to beginning of day.
            date.setHours(0, 0, 0, 0);
            // In JavaScript, getDay() returns 0 for Sunday, 1 for Monday, …, 6 for Saturday.
            // We want the week to start on Saturday.
            // If today is Saturday (6), we stay; if Sunday (0), subtract 1 day; if Monday (1), subtract 2 days; etc.
            const day = date.getDay();
            const diff = (day + 1) % 7;  // Saturday => (6+1)%7 = 0; Sunday => (0+1)%7 = 1; etc.
            date.setDate(date.getDate() - diff);
            break;
        }
        case "1M": { // Beginning of month
            date.setDate(1);
            date.setHours(0, 0, 0, 0);
            break;
        }
        default:
            throw new Error("Invalid bucket code. Must be an integer between 0 and 7.");
    }

    return date.getTime();
}

export const generateTradingViewSession = (tradingDays: boolean[], tradingTime: number[], firstDay: number): string => {
    const dayMappings = ['1', '2', '3', '4', '5', '6', '7'];
    // 1. Get local offset in hours (e.g., +2)
    const offsetHours = -new Date().getTimezoneOffset() / 60;
    // 2. Simple conversion function
    const toLocal = (hhmm: number) => {
        let hours = Math.floor(hhmm / 100);
        let mins = hhmm % 100;

        // Add offset and wrap around 24 hours
        let localHours = (hours + offsetHours + 24) % 24;

        return localHours * 100 + mins;
    };

    const startTime = toLocal(tradingTime[0] || 0).toString().padStart(4, '0');
    const endTime = toLocal(tradingTime[1] || 2359).toString().padStart(4, '0');

    const daysString = tradingDays.map((day, index) => day ? dayMappings[index] : '').filter(Boolean).join('');

    return `${startTime}-${endTime}:${daysString};${firstDay + 1}`;
};



const CONFIG_CACHE: Record<string, {
    startH: number, startM: number, endH: number, endM: number,
    days: boolean[], weekStart: number, is24x7: boolean
}> = {};


 export function getTradingSessionTimestamp(
    tickInput: Date | number,
    resolution: string,
    sessionStr: string
): number {
    // Safety: Ensure valid input is passed
    if (!tickInput) {
        tickInput = new Date();
    }

    // Conversion: Works whether 'tickInput' is a Date object OR a number
    const tick = new Date(tickInput);
    // ─────────────────────────────────────────────────────────────
    // 1. Config Parsing
    // ─────────────────────────────────────────────────────────────
    let cfg = CONFIG_CACHE[sessionStr];
    if (!cfg) {
        const [times, dayPart] = sessionStr.split(':');
        const [start, end] = times.split('-');
        let daysStr = "1234567";
        let weekStart = 1;

        if (dayPart) {
            const parts = dayPart.split(';');
            daysStr = parts[0];
            if (parts[1]) weekStart = parseInt(parts[1]);
        }

        const startH = parseInt(start.substring(0, 2));
        const startM = parseInt(start.substring(2, 4));
        const endH = parseInt(end.substring(0, 2));
        const endM = parseInt(end.substring(2, 4));

        // Detect 24x7 if "24x7" string OR start == end (0000-0000)
        const is24x7 = (sessionStr === "24x7") || (startH === endH && startM === endM);

        cfg = {
            startH, startM, endH, endM, weekStart, is24x7,
            days: new Array(8).fill(false)
        };
        for (let i = 0; i < daysStr.length; i++) cfg.days[parseInt(daysStr[i])] = true;
        CONFIG_CACHE[sessionStr] = cfg;
    }

    // Parse Resolution
    let resMs = 0;
    if (resolution === "1D") resMs = 86400000;
    else if (resolution === "1W") resMs = 604800000;
    else if (resolution.endsWith("M")) resMs = -1;
    else resMs = parseInt(resolution) * 60000;

    // ─────────────────────────────────────────────────────────────
    // 2. High Timeframe Logic
    // ─────────────────────────────────────────────────────────────
    const result = new Date(tick);
    const currentTVDay = result.getDay() + 1;

    if (resMs === -1) { // Monthly
        result.setDate(1);
        result.setHours(cfg.startH, cfg.startM, 0, 0);
        while (!cfg.days[result.getDay() + 1]) result.setDate(result.getDate() + 1);
        return result.getTime();
    }
    if (resolution === "1W") {
        result.setHours(cfg.startH, cfg.startM, 0, 0);
        const diff = (currentTVDay - cfg.weekStart + 7) % 7;
        result.setDate(result.getDate() - diff);
        while (!cfg.days[result.getDay() + 1] && result.getTime() < tick.getTime()) {
            result.setDate(result.getDate() + 1);
        }
        return result.getTime();
    }

    // ─────────────────────────────────────────────────────────────
    // 3. Daily/Intraday Logic with Midnight Fix
    // ─────────────────────────────────────────────────────────────
    const tickTimeVal = tick.getHours() * 100 + tick.getMinutes();
    const endTimeVal = cfg.endH * 100 + cfg.endM;

    // Only check "Past End Time" if it is NOT a 24x7/Midnight session
    let isClosed = !cfg.days[currentTVDay];
    if (!isClosed && !cfg.is24x7) {
        if (tickTimeVal >= endTimeVal) isClosed = true;
    }

    if (isClosed) {
        do {
            result.setDate(result.getDate() + 1);
        } while (!cfg.days[result.getDay() + 1]);
        result.setHours(cfg.startH, cfg.startM, 0, 0);
        return result.getTime();
    }

    // ─────────────────────────────────────────────────────────────
    // 4. Intraday Bucketing (Verified for 1 Minute)
    // ─────────────────────────────────────────────────────────────
    result.setHours(cfg.startH, cfg.startM, 0, 0);

    if (resolution === "1D") return result.getTime();

    const sessionStartMs = result.getTime();
    const tickMs = tick.getTime();

    // Safety check
    if (tickMs < sessionStartMs) return sessionStartMs;

    const diffMs = tickMs - sessionStartMs;
    const buckets = Math.floor(diffMs / resMs);

    return sessionStartMs + (buckets * resMs);
}
